import FaresCarouselBackgroundImageContainer from '../../../../components/containers/FaresCarouselBackgroundImageContainer';
import preloadCustomProps from '../../../utils/preloads/preloadFareProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'fares-carousel-background-image',
  moduleId: 'em-cmp-lib-airmodules',
  staticAssetsHost: 'https://em-frontend-assets.airtrfx.com',
  version: 'NO_NEEDED',
  containerConfig: {
    settings: {
      instance: FaresCarouselBackgroundImageContainer
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
